import React from "react";
import { Grid, Header, Segment } from "semantic-ui-react";

class AdvancedAnalyticsView extends React.Component {
  render() {
    // const url = sessionStorage.getItem("se_dashboard_url");
    // const seDashboardToken = sessionStorage.getItem("se_dashboard_token");
    // const [{ seCompanyAccessToken }] = useLogin();
    
    return (
      <iframe
        title="Advanced analytics"
        src="https://dev-aa.guardian-cms.com/?workspaceId=effe1f38-22f9-4264-8466-6cda445419e8&reportId=bded63bc-aa0b-4713-b3fb-5169a0ece451&loggedInUser=James@rbw.systems"
        className="height-100 gs-flex-container flex-between"
        style={{ border: "none" }}
      />

    );
  }
}

export default AdvancedAnalyticsView;

